<template>
  <div class="horizontal-bar-chart">
    <div class="chart-item" v-for="item in orderedData" :key="item.key + ''">
      <p>{{ item.key }}</p>
      <div class="bar-wrapper">
        <div class="bar" :style="{ 'width': barWidth(item), 'background-color': item.colour }">
          <span class="bar-label">{{ item.value }} ({{ percentage(item.value) }})</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

export interface CategoryCountDataItem {
  key: string;
  value: number;
  colour: string;
}

export type CategoryCountData = CategoryCountDataItem[];

const props = defineProps<{
  data: CategoryCountData;
}>();

const orderedData = computed(() => {
  return props.data?.slice().sort((a, b) => {
    return b.value - a.value;
  });
});

const maxValue = computed(() => {
  return Math.max(...(props.data?.map((i) => i.value) ?? 0));
});

const sumOfValues = computed(() => {
  return props.data?.reduce((sum, item) => {
    return sum + (item.value || 0);
  }, 0);
});

function barWidth(item: CategoryCountDataItem): string {
  const fraction = item.value / maxValue.value;
  return `${fraction * 100}%`;
}

function percentage(value: number): string {
  return sumOfValues.value <= 0 ? "" : `${Math.round((value * 100) / sumOfValues.value)}%`;
}
</script>
<style lang="less" scoped>
.chart-item {
  margin-bottom: 15px;

  p {
    margin: 0;
    margin-bottom: 5px;
  }
}

.bar-wrapper {
  padding-right: 9rem;
}

.bar {
  height: 20px;
  display: block;
  position: relative;
}

.bar-label {
  position: absolute;
  left: 100%;
  color: black;
  top: -0.15em;
  margin-left: 10px;
  white-space: nowrap;
}
</style>
